import { useEffect, useState } from "react";

// simple debounce hook
export function useDebounce<T>(value: T, delay: number, enabled: boolean) {
  const [debounced, setDebounced] = useState(value);
  const [isDebouncing, setIsDebouncing] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  useEffect(() => {
    // If disabled, do nothing
    if (!enabled) {
      return;
    } else if (!initialLoadComplete) {
      // If initial load is not complete, set the debounced value and return
      setInitialLoadComplete(true);
      setDebounced(value);
      return;
    } else {
      // Else debounce the value
      setIsDebouncing(true);

      const id = setTimeout(() => {
        setDebounced(value);
        setIsDebouncing(false);
      }, delay);

      return () => clearTimeout(id);
    }
  }, [value, delay, enabled]);

  return { debounced, isDebouncing };
}
